import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 123 123",
  "enable-background": "new 0 0 123 123",
  class: "icon-search_svg__svg-search",
  "aria-hidden": "true",
  focusable: "false"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M119.046 99.954L92.74 73.65l.83-1.62C97.175 64.995 99 57.416 99 49.5 99 22.206 76.794 0 49.5 0S0 22.206 0 49.5 22.206 99 49.5 99c7.916 0 15.495-1.826 22.528-5.43l1.62-.83 26.305 26.306c2.55 2.55 5.94 3.954 9.547 3.954s6.996-1.404 9.546-3.954S123 113.106 123 109.5s-1.404-6.996-3.954-9.546zM49.5 80C32.682 80 19 66.317 19 49.5 19 32.682 32.682 19 49.5 19 66.317 19 80 32.682 80 49.5 80 66.317 66.317 80 49.5 80z" }, null, -1)
  ])))
}
export default { render: render }